<div class="vd-logo" [class.animated]="animated" [attr.data-variant]="variant" [style.--logo-size.px]="pxSize()">
  <svg
    class="vd-logo-svg"
    [attr.width]="pxSize()"
    [attr.height]="pxSize()"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Vendeur.site"
  >
    <defs>
      <linearGradient id="vd-grad-frame" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#3730a3"/>
        <stop offset="50%" stop-color="#4338ca"/>
        <stop offset="100%" stop-color="#312e81"/>
      </linearGradient>
      <linearGradient id="vd-grad-basket" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#22d3ee"/>
        <stop offset="60%" stop-color="#06b6d4"/>
        <stop offset="100%" stop-color="#0891b2"/>
      </linearGradient>
      <linearGradient id="vd-grad-cloud" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#67e8f9"/>
        <stop offset="100%" stop-color="#22d3ee"/>
      </linearGradient>
      <radialGradient id="vd-grad-glow" cx="50%" cy="50%" r="55%">
        <stop offset="0%" stop-color="rgba(99,102,241,0.55)"/>
        <stop offset="100%" stop-color="rgba(99,102,241,0)"/>
      </radialGradient>
      <filter id="vd-soft-shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur stdDeviation="1.5"/>
      </filter>
    </defs>

    <!-- Halo lumineux animé -->
    <circle class="vd-logo-glow" cx="60" cy="60" r="58" fill="url(#vd-grad-glow)"/>

    <!-- Caddie : le caddy entier remue (bounce + tilt léger comme s'il roule) -->
    <g class="vd-logo-cart">
      <!-- Cadre arrière du chariot (forme "C" inversé)
           silhouette inspirée du logo original : un chariot tech avec
           poignée gauche, fond en U, roues en bas, panier-nuage qui flotte -->
      <path
        class="vd-frame-back"
        d="M 16 36
           L 16 30
           Q 16 24 22 24
           L 30 24
           Q 36 24 36 30
           L 36 36
           Z"
        fill="url(#vd-grad-frame)"
      />
      <!-- Poignée verticale gauche du chariot -->
      <path
        class="vd-frame-handle"
        d="M 22 26
           L 22 78
           Q 22 84 28 84
           L 36 84
           Z"
        fill="url(#vd-grad-frame)"
      />
      <!-- Panier principal cyan (forme arrondie typique caddie) -->
      <path
        class="vd-basket"
        d="M 30 44
           Q 26 44 28 50
           L 38 86
           Q 40 92 46 92
           L 92 92
           Q 98 92 100 86
           L 108 50
           Q 110 44 104 44
           Z"
        fill="url(#vd-grad-basket)"
      />

      <!-- Nuage qui dépasse du panier (le cloud iconique) -->
      <g class="vd-cloud-wrap">
        <path
          class="vd-cloud"
          d="M 50 44
             Q 46 36 54 32
             Q 56 26 64 28
             Q 70 24 78 30
             Q 86 30 86 38
             Q 90 42 84 44
             Z"
          fill="url(#vd-grad-cloud)"
        />
      </g>

      <!-- Balises code </> au centre du panier (blanc sur cyan) -->
      <g class="vd-code" stroke="#ffffff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <!-- < -->
        <path d="M 56 62 L 50 70 L 56 78"/>
        <!-- / -->
        <path d="M 72 58 L 62 82"/>
        <!-- > -->
        <path d="M 78 62 L 84 70 L 78 78"/>
      </g>
    </g>

    <!-- Roues (en dehors du groupe cart pour qu'elles roulent uniquement) -->
    <g class="vd-wheel vd-wheel-left">
      <circle cx="50" cy="100" r="8" fill="url(#vd-grad-frame)"/>
      <circle cx="50" cy="100" r="3" fill="#ffffff"/>
      <line x1="50" y1="92" x2="50" y2="108" stroke="#a5b4fc" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
      <line x1="42" y1="100" x2="58" y2="100" stroke="#a5b4fc" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
    </g>
    <g class="vd-wheel vd-wheel-right">
      <circle cx="88" cy="100" r="8" fill="url(#vd-grad-frame)"/>
      <circle cx="88" cy="100" r="3" fill="#ffffff"/>
      <line x1="88" y1="92" x2="88" y2="108" stroke="#a5b4fc" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
      <line x1="80" y1="100" x2="96" y2="100" stroke="#a5b4fc" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
    </g>

    <!-- Petites particules orbitales -->
    <g class="vd-logo-particles">
      <circle class="vd-particle p1" cx="106" cy="22" r="2.5" fill="#06b6d4"/>
      <circle class="vd-particle p2" cx="14"  cy="34" r="2"   fill="#8b5cf6"/>
      <circle class="vd-particle p3" cx="108" cy="68" r="1.8" fill="#6366f1"/>
      <circle class="vd-particle p4" cx="12"  cy="68" r="2.2" fill="#22d3ee"/>
    </g>
  </svg>

  <span *ngIf="showWordmark" class="vd-logo-wordmark">
    <span class="vd-wm-v">V</span><span class="vd-wm-rest">endeur</span><span class="vd-wm-dot">.</span><span class="vd-wm-site">site</span>
  </span>
</div>
